import {HuePicker} from 'react-color';

import BaseComponent from "../../../../baseComponent.js";
import styles from "./styles.scss";

export default class CustomColor extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: this.props.color
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({color: nextProps.color});
  }

  handleChange(event) {
    const value = event.target.value;
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(value);
    if (isValid) {
      this.props.onChange("color", value);
    }
    this.setState({color: value});
  }

  render() {
    return (
        <div className={styles.customColor} ref="container">
          <HuePicker color={this.props.color} onChange={color => this.props.onChange("color", color.hex)}
                     width="170px"/>
          <input type="text" value={this.state.color} onChange={this.handleChange} spellCheck="false"/>
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/customColor.jsx